export default __webpack_public_path__ + "static/visual_4-f9d4d44241a2aeca700dc38f80da4f8f.jpg";